var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-content-loading',{attrs:{"weight":100,"height":200}},[_c('rect',{attrs:{"x":"1%","y":"0","rx":"10","ry":"10","width":"98%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }